var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsaxLinearLinksquare2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1801 16.0201C7.4201 15.9501 6.6701 15.6001 6.0901 14.9901C4.7701 13.6001 4.7701 11.3201 6.0901 9.93011L8.2801 7.63011C8.58934 7.301 8.96271 7.03872 9.3772 6.85943C9.79168 6.68014 10.2385 6.58765 10.6901 6.58765C11.1417 6.58765 11.5885 6.68014 12.003 6.85943C12.4175 7.03872 12.7909 7.301 13.1001 7.63011C14.4201 9.02011 14.4201 11.3001 13.1001 12.6901L12.0101 13.8401",
    stroke: "#F5F5F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8199 7.97998C16.5799 8.04998 17.3299 8.39998 17.9099 9.00998C19.2299 10.4 19.2299 12.68 17.9099 14.07L15.7199 16.37C15.4107 16.6991 15.0373 16.9614 14.6228 17.1407C14.2083 17.3199 13.7615 17.4124 13.3099 17.4124C12.8583 17.4124 12.4115 17.3199 11.997 17.1407C11.5825 16.9614 11.2092 16.6991 10.8999 16.37C9.57991 14.98 9.57991 12.7 10.8999 11.31L11.9899 10.16",
    stroke: "#F5F5F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxLinearLinksquare2X);
export default __webpack_public_path__ + "static/media/iconsax-linear-linksquare@2x.376c7fb4f033e0ce380b858c684b52a0.svg";
export { ForwardRef as ReactComponent };